// DEPRECATION NOTICE: Originally from UG LMS, should be removed. https://descomplica.slack.com/archives/CJFJQQY1K/p1713359793357089

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
  state,
  getters,
  mutations,
  actions,
};
